import React, { useEffect, useState } from 'react';
import { GetWordsList } from '../Adapters/GetWordsList';
import i18next from 'i18next';
import { useAtom } from 'jotai';
import { searchAtom } from '../shared/Atom.search';
import { languageAtom } from '../shared/Atom.language';
import useGetLanguages from 'Global/Hooks/useGetLanguages';
import { FindPreferredLang } from 'utils/FindPreferredLang';
import { Post } from 'Xhr/Xhr';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';

const useData = (forceRender) => {
  const [search] = useAtom(searchAtom);
  const [language] = useAtom(languageAtom);
  const [words, setWords] = useState();

  useEffect(() => {
    if (Array.isArray(language)) {
      return;
    }

    Post(
      'Post',
      `${process.env.REACT_APP_API_URL_API_LIST_LOCALIZATION_LANGUAGE}`,
      true,
      {
        DistinitationLanguage: language,
        SearchKey: search,
        TopRecord: '200',
      }
    ).then((response) => {
      if (response.data.resCode === 1) {
        setWords(response.data.Data);
      } else {
        SwalAlert('error', response.data.resMessage, false);
      }
    });
  }, [forceRender, search, language]);

  const languageOptions = useGetLanguages(true);
  const initialLang = FindPreferredLang();
  return {
    words,
    languageOptions,
    initialLang,
  };
};

export default useData;
